import React, { useEffect, useMemo } from 'react';

const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/saverly-kroger-meals/id6756591268';
const ANDROID_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.saverly.app&hl=en_US';
const DOWNLOAD_FALLBACK_URL = '/download';
const APP_SCHEME_URL = 'saverly://';

function getPlatform() {
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  return 'web';
}

export default function AppRedirectPage() {
  const platform = useMemo(getPlatform, []);
  const search = window.location.search || '';
  const appSchemeUrl = `${APP_SCHEME_URL}${search}`;

  useEffect(() => {
    const fallbackUrl =
      platform === 'ios'
        ? IOS_APP_STORE_URL
        : platform === 'android'
          ? ANDROID_PLAY_URL
          : DOWNLOAD_FALLBACK_URL;

    const timeout = setTimeout(() => {
      window.location.href = fallbackUrl;
    }, 1500);

    window.location.href = appSchemeUrl;

    return () => clearTimeout(timeout);
  }, [appSchemeUrl, platform]);

  const fallbackUrl =
    platform === 'ios'
      ? IOS_APP_STORE_URL
      : platform === 'android'
        ? ANDROID_PLAY_URL
        : DOWNLOAD_FALLBACK_URL;

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 text-center">
      <h1 className="text-2xl font-semibold text-gray-900 mb-3">Opening Saverly...</h1>
      <p className="text-gray-600 mb-6">
        If the app doesn&apos;t open automatically, use the button below.
      </p>
      <div className="flex flex-col gap-3 w-full max-w-sm">
        <a
          href={appSchemeUrl}
          className="w-full rounded-lg bg-saverly-primary text-white py-3 font-semibold"
        >
          Open Saverly
        </a>
        <a
          href={fallbackUrl}
          className="w-full rounded-lg border border-gray-200 text-gray-700 py-3 font-semibold"
        >
          {platform === 'ios'
            ? 'Get on the App Store'
            : platform === 'android'
              ? 'Get on Google Play'
              : 'Go to Download Page'}
        </a>
      </div>
    </div>
  );
}
